import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 40px;
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 40px;
  min-height: 80vh;
`;

const H = styled.h2`
  color: white;
  font-weight: 700;
`;

export const S = {
  Container,
  H,
};
